module.exports = __webpack_public_path__ + "img/icon-trezor.19f6da90.svg";